"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onOff = exports.bitSet = exports.gpsYoung = exports.gpsFix = exports.errors = exports.detected = exports.openClosed = exports.charging = exports.reboot = exports.ack = exports.yesNo = exports.mode = void 0;
var mode;
(function (mode) {
    mode[mode["ACTIVE"] = 0] = "ACTIVE";
    mode[mode["TRANSPORT"] = 1] = "TRANSPORT";
})(mode || (exports.mode = mode = {}));
var yesNo;
(function (yesNo) {
    yesNo[yesNo["NO"] = 0] = "NO";
    yesNo[yesNo["YES"] = 1] = "YES";
})(yesNo || (exports.yesNo = yesNo = {}));
var reboot;
(function (reboot) {
    reboot[reboot["NORMAL"] = 0] = "NORMAL";
    reboot[reboot["REBOOTED"] = 1] = "REBOOTED";
})(reboot || (exports.reboot = reboot = {}));
var ack;
(function (ack) {
    ack[ack["NOACK"] = 0] = "NOACK";
    ack[ack["ACK"] = 1] = "ACK";
})(ack || (exports.ack = ack = {}));
var openClosed;
(function (openClosed) {
    openClosed[openClosed["CLOSED"] = 0] = "CLOSED";
    openClosed[openClosed["OPEN"] = 1] = "OPEN";
})(openClosed || (exports.openClosed = openClosed = {}));
var detected;
(function (detected) {
    detected[detected["NOT_DETECTED"] = 0] = "NOT_DETECTED";
    detected[detected["DETECTED"] = 1] = "DETECTED";
})(detected || (exports.detected = detected = {}));
var charging;
(function (charging) {
    charging[charging["NOT_CHARGING"] = 0] = "NOT_CHARGING";
    charging[charging["CHARGING"] = 1] = "CHARGING";
})(charging || (exports.charging = charging = {}));
var errors;
(function (errors) {
    errors[errors["OK"] = 0] = "OK";
    errors[errors["ERRORS"] = 1] = "ERRORS";
})(errors || (exports.errors = errors = {}));
var gpsFix;
(function (gpsFix) {
    gpsFix[gpsFix["NO_FIX"] = 0] = "NO_FIX";
    gpsFix[gpsFix["FIX"] = 1] = "FIX";
})(gpsFix || (exports.gpsFix = gpsFix = {}));
var gpsYoung;
(function (gpsYoung) {
    gpsYoung[gpsYoung["OLD"] = 0] = "OLD";
    gpsYoung[gpsYoung["YOUNG"] = 1] = "YOUNG";
})(gpsYoung || (exports.gpsYoung = gpsYoung = {}));
var bitSet;
(function (bitSet) {
    bitSet[bitSet["NOT_SET"] = 0] = "NOT_SET";
    bitSet[bitSet["SET"] = 1] = "SET";
})(bitSet || (exports.bitSet = bitSet = {}));
var onOff;
(function (onOff) {
    onOff[onOff["OFF"] = 0] = "OFF";
    onOff[onOff["ON"] = 1] = "ON";
})(onOff || (exports.onOff = onOff = {}));
